import { render } from "./ViewDynamicAssets.vue?vue&type=template&id=583a3e24"
import script from "./ViewDynamicAssets.vue?vue&type=script&lang=js"
export * from "./ViewDynamicAssets.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__